import { Shelf, Stack } from "capitalrx-components-2.0/lib/layout";
import { Body, Heading, Subheading } from "capitalrx-components-2.0/lib/typography";
import { useSearchParams } from "react-router";
import { Card } from "@/premium/themedComponents";
import "./PharmacyDetailsPage.scss";
import { formatDollars } from "capitalrx-utilities";
import { useTranslation } from "react-i18next";

const TRANSLATION_PATH = "PHARMACY_DETAILS_PAGE";

export const PaymentSummaryPanel = () => {
  const { t: translate } = useTranslation();
  const [searchParams] = useSearchParams();

  const patientPayAmount = decodeURIComponent(searchParams.get("patientPay") || "");
  const planPayAmount = decodeURIComponent(searchParams.get("planPay") || "");
  const formattedTotalPay = formatDollars((Number(patientPayAmount) + Number(planPayAmount)).toString());
  const formattedPatientPayAmount = formatDollars(patientPayAmount || "0");
  const formattedPlanPayAmount = formatDollars(planPayAmount || "0");

  return (
    <Stack>
      <Heading>{translate(`${TRANSLATION_PATH}.paymentSummary`)}</Heading>
      <Card className="card">
        <Stack>
          <Stack style={{ borderBottom: "1px solid #CFD9E1", paddingBottom: "20px" }}>
            <Shelf>
              <Body>{translate(`${TRANSLATION_PATH}.totalAmount`)}</Body>
              <Shelf.Spacer />
              <Body>{formattedTotalPay}</Body>
            </Shelf>
            <Shelf>
              <Body>{translate(`${TRANSLATION_PATH}.planPays`)}</Body>
              <Shelf.Spacer />
              <Body>{formattedPlanPayAmount}</Body>
            </Shelf>
          </Stack>
          <Shelf>
            <Subheading>{translate(`${TRANSLATION_PATH}.memberPays`)}</Subheading>
            <Shelf.Spacer />
            <Subheading>{formattedPatientPayAmount}</Subheading>
          </Shelf>
        </Stack>
      </Card>
    </Stack>
  );
};
